import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import React from "react";
import { Grid } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxSlider from "components/UI/AcxSlider";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "utils/useStore";
import theme from "Theme/AppTheme";

function getSimilarityLabel(sliderValue: number): string {
    const threshold = sliderValue;

    if (threshold >= 0.75) return "(exact or nearly identical)";
    if (threshold >= 0.65) return "(very strong match)";
    if (threshold >= 0.5) return "(strong match)";
    if (threshold >= 0.4) return "(moderately strong match)";
    if (threshold >= 0.3) return "(moderate similarity)";
    if (threshold >= 0.2) return "(loosely related)";
    if (threshold >= 0.1) return "(weak similarity)";
    if (threshold > 0) return "(minimal relevance)";
    return "(no filtering, include all)";
}

export const SemanticSearchFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const authStore = useStore(AuthStore);

    if (!authStore.canUserView("AI Search")) return null;

    return (
        <Grid
            container
            direction="column"
            flexWrap="nowrap"
            padding={2}
            borderRadius={1}
            sx={(theme) => ({
                backgroundColor: theme.palette.lightgray,
            })}
            xs={12}
        >
            <Grid item xs={12} paddingBottom={theme.spacing(1)}>
                <AcxMainTextField
                    id="semantic-search-query"
                    fullWidth
                    sx={{
                        border: "none",
                        borderRadius: "4px",
                    }}
                    placeholderText="Type to add..."
                    value={props.store.embeddedTranscriptionQuery}
                    onChange={(event) => {
                        const text = event.target.value;
                        props.store.setEmbeddedTranscriptionQuery(text);
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <AcxSlider
                    label="Search Precision"
                    description={getSimilarityLabel(
                        props.store.embeddedTranscriptionQueryThreshold,
                    )}
                    value={props.store.embeddedTranscriptionQueryThreshold}
                    onChange={(duration) => {
                        props.store.setEmbeddedTranscriptionQueryThreshold(
                            duration,
                        );
                    }}
                    minValue={0}
                    maxValue={1}
                    step={0.01}
                    sx={{
                        paddingTop: "8px",
                        paddingBottom: "4px",
                        ".MuiSlider-track": {
                            border: "none",
                        },
                    }}
                    labelSx={(theme) => ({
                        color: theme.palette.gray[700],
                        fontSize: "14px",
                        lineHeight: "20px",
                    })}
                    descriptionSx={(theme) => ({
                        color: theme.palette.gray[500],
                        fontSize: "12px",
                    })}
                />
            </Grid>
        </Grid>
    );
});
